module.exports = {"id":"220132","name":"Zaldúa","rating":"73","photo":"./data/images/photos/2/220132.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Zaldua0.json
// module id = 4461
// module chunks = 0